// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","737":"fb7d5399"}[chunkId] + "-" + {"218":"688d638987f6db45774f","691":"a9a0f467fb9d3cc386ec","737":"1061d2280390fbd37f49"}[chunkId] + ".js";
};